'use client';

import React, { memo, useState, useEffect } from 'react';
import { useWindowScroll, useLocalStorage } from 'react-use';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import classNames from 'classnames';
import styles from './styles.module.scss';

const CookieNoticeContent = memo(props => (
  <div className={classNames(styles.cookieNotice, props.show && styles.show)}>
    <div className={styles.content}>
      <div className={styles.title}>We value your privacy</div>
      <div className={styles.description}>
        {`We use cookies to enhance your browsing experience, personalise content
        and ads, provide social media features and analyse our traffic. By
        clicking 'Accept all', you consent to our use of cookies.`}
      </div>
      <div>
        <Link href="/legal/cookies" target={'_blank'}>
          <span className={styles.privacyLink}>Read our cookie policy</span>
        </Link>
      </div>
    </div>
    <div className={styles.actions}>
      <div className={classNames(styles.actionButton, styles.reject)} onClick={() => props.hide()}>
        Reject All
      </div>
      <div className={classNames(styles.actionButton, styles.accept)} onClick={() => props.hide()}>
        Accept All
      </div>
    </div>
  </div>
));

const CookieNotice = props => {
  const { y } = useWindowScroll();

  const showCookieNotice = y > 1400;

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!show && showCookieNotice === true) {
      setShow(true);
    }
  }, [showCookieNotice, show]);

  return <CookieNoticeContent show={show} hide={props.hide} />;
};

const DismissWrapperComponent = () => {
  const [dismissed, setDismissed] = useLocalStorage('alfa-cookie-notice', 'false');

  function hide() {
    setDismissed('accepted');
  }

  if (dismissed !== 'false') {
    return null;
  }

  return <CookieNotice hide={hide} />;
};

const DismissWrapper = dynamic(() => Promise.resolve(DismissWrapperComponent), {
  ssr: false,
});

export default DismissWrapper;
